import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Card, CardContent, Divider, Grid } from '@material-ui/core';
import styles from './../../style';
import { SoapMeta, SoapLeft, MHx } from './components';
import { connect } from 'react-redux';
import {
  getPatientActiveMedications,
  getPatientInactiveDiagnosis,
  getPatientInactiveMedication,
  getPatientMedicalHistory,
  getPatientPastDiagnosis,
  getPatientRemarks,
  getPastSoapNoteById,
  saveTempData
} from 'services/soap/action';
import { getProviders } from 'services/util/action';
import { getPatientCharts } from 'services/home/action';
const AccountDetails = ({
  classes,
  className,
  patientId,
  ehrID,
  editfromChartReview,
  getPatientActiveMedications,
  getPatientInactiveDiagnosis,
  getPatientInactiveMedication,
  getPatientMedicalHistory,
  getPatientPastDiagnosis,
  getPatientRemarks,
  getPastSoapNoteById,
  saveTempData,
  getProviders, 
  getPatientCharts,
  ...rest
}) => {
  
  const childRefSoap = useRef();

  useEffect(() => {
    if (!patientId) return; 
    const fetchData = async () => {
      getPatientActiveMedications(patientId);
      getPatientInactiveDiagnosis(patientId);
      getPatientInactiveMedication(patientId);
      getPatientPastDiagnosis(patientId);
      getPatientMedicalHistory(patientId); 
      getPatientRemarks(patientId);
      getPastSoapNoteById(patientId, 0);
      getProviders(ehrID);  
      getPatientCharts(patientId, 0);
    };
    fetchData();
  }, [patientId]);

  const handleCopy = async (
    dia,
    cpt,
    isClearDiagnosis = false,
    isClearCPT = false
  ) => {
    let datanew = await childRefSoap.current.getValuesforCopy();
    let newState = datanew ? datanew : [];
    let newStateSoap,
      newStatedia,
      newStatecpt,
      newStatePastSoapNoteDetails = [];
    if (datanew && (datanew.soap || datanew.pastSoapNoteDetails)) {
      newStateSoap = newState.soap ? newState.soap : [];
      newStatePastSoapNoteDetails = newState.pastSoapNoteDetails
        ? newState.pastSoapNoteDetails
        : [];
      newStatedia = newState.pastSoapNoteDetails.diagnosisList
        ? newState.pastSoapNoteDetails.diagnosisList
        : [];

      newStatecpt = newState.pastSoapNoteDetails.cptList
        ? newState.pastSoapNoteDetails.cptList
        : [];

      if (isClearDiagnosis) {
        newStatePastSoapNoteDetails.diagnosisList = dia;
        // setDiagnosis(dia);
      }

      if (isClearCPT) {
        newStatePastSoapNoteDetails.cptList = cpt;
        //  setCpt(cpt);
      }
      if (dia && dia.length > 0 && !isClearDiagnosis) {
        if (
          newStatePastSoapNoteDetails.diagnosisList &&
          newStatePastSoapNoteDetails.diagnosisList.length > 0
        ) {
          //  newStatedia = [...newStatePastSoapNoteDetails.diagnosisList];
          dia.map(item => {
            if (!newStatedia.some(c => c.description === item.description)) {
              newStatedia.push({
                code: item.code,
                codeType: item.codeType,
                description: item.description,
                oldPastDiagnosisId: item.oldPastDiagnosisId,
                soapId: item.soapId,
                sortOrder: item.sortOrder
              });
            }
          });
          newStatePastSoapNoteDetails.diagnosisList = newStatedia;
        } else {
          if (newStatePastSoapNoteDetails.diagnosisList === undefined) {
            newStatePastSoapNoteDetails.diagnosisList = [];
          }
          newStatePastSoapNoteDetails.diagnosisList.push({
            code: dia[0].code,
            codeType: dia[0].codeType,
            description: dia[0].description,
            oldPastDiagnosisId: dia[0].oldPastDiagnosisId,
            soapId: dia[0].soapId,
            sortOrder: dia[0].sortOrder
          });
        }
      }
      if (cpt && cpt.length > 0 && !isClearCPT) {
        if (
          newStatePastSoapNoteDetails.cptList &&
          newStatePastSoapNoteDetails.cptList.length > 0
        ) {
          // newStatecpt = [...newStatePastSoapNoteDetails.cptList];
          cpt.map(item => {
            if (!newStatecpt.some(c => c.description === item.description)) {
              newStatecpt.push({
                code: item.code,
                codeType: item.codeType,
                description: item.description,
                oldPastDiagnosisId: item.oldPastDiagnosisId,
                soapId: item.soapId,
                sortOrder: item.sortOrder
              });
            }
          });
          newStatePastSoapNoteDetails.cptList = newStatecpt;
        } else {
          if (newStatePastSoapNoteDetails.cptList === undefined) {
            newStatePastSoapNoteDetails.cptList = [];
          }
          newStatePastSoapNoteDetails.cptList.push({
            code: cpt[0].code,
            codeType: cpt[0].codeType,
            description: cpt[0].description,
            oldPastDiagnosisId: cpt[0].oldPastDiagnosisId,
            soapId: cpt[0].soapId,
            sortOrder: cpt[0].sortOrder
          });
        }
      }
    } else if (Object.entries(datanew).length > 0) {
      newState = { soap: datanew, pastSoapNoteDetails: {} };
      if (dia && dia.length > 0) {
        newState.pastSoapNoteDetails.diagnosisList =
          newState.soap.diagnosisList &&
            newState.soap.diagnosisList.length > 0
            ? newState.soap.diagnosisList
            : [];
        newState.pastSoapNoteDetails.diagnosisList.push({
          code: dia[0].code,
          codeType: dia[0].codeType,
          description: dia[0].description,
          oldPastDiagnosisId: dia[0].oldPastDiagnosisId,
          soapId: dia[0].soapId,
          sortOrder: dia[0].sortOrder
        });
      } else if (cpt && cpt.length > 0) {
        newState.pastSoapNoteDetails.cptList =
          newState.soap.cptList && newState.soap.cptList.length > 0
            ? newState.soap.cptList
            : [];
        newState.pastSoapNoteDetails.cptList.push({
          code: cpt[0].code,
          codeType: cpt[0].codeType,
          description: cpt[0].description,
          oldPastDiagnosisId: cpt[0].oldPastDiagnosisId,
          soapId: cpt[0].soapId,
          sortOrder: cpt[0].sortOrder
        });
      }
    } else {
      newState.soap = [];
      newState.pastSoapNoteDetails = [];
      if (dia && dia.length > 0) {
        newState.pastSoapNoteDetails.diagnosisList = [];
        newState.pastSoapNoteDetails.diagnosisList.push({
          code: dia[0].code,
          codeType: dia[0].codeType,
          description: dia[0].description,
          oldPastDiagnosisId: dia[0].oldPastDiagnosisId,
          soapId: dia[0].soapId,
          sortOrder: dia[0].sortOrder
        });
      } else if (cpt && cpt.length > 0) {
        newState.pastSoapNoteDetails.cptList = [];
        newState.pastSoapNoteDetails.cptList.push({
          code: cpt[0].code,
          codeType: cpt[0].codeType,
          description: cpt[0].description,
          oldPastDiagnosisId: cpt[0].oldPastDiagnosisId,
          soapId: cpt[0].soapId,
          sortOrder: cpt[0].sortOrder
        });
      }
    }
    newState.fromIsMHx = true;
    await saveTempData(newState);
    childRefSoap.current.loadCPT(newState);
  };

  return (
    <Grid container spacing={3}>
      <Grid item md={12} xs={12}>
        <Card {...rest} className={clsx(classes.subTabRoot, className)}>
          <SoapMeta patientId={patientId} />
          <Divider />
          <CardContent style={{ padding: 0 }}>
            <Grid container>
              <Grid item md={8} xs={12}>
                <SoapLeft
                  editfromChartReview={editfromChartReview}
                  clearLocationandEditChartView={rest.clearLocationandEditChartView}
                  handleCopy={handleCopy}
                  ref={childRefSoap}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <PerfectScrollbar style={{ height: 'calc(110vh - 0px)', paddingRight: 10 }}>
                  <MHx handleCopy={handleCopy} />
                </PerfectScrollbar>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

AccountDetails.propTypes = { className: PropTypes.string };

export default withRouter(
  connect(
    state => ({
      ehrID: state.profile?.ehrID,
      userID: state.profile?.userID,
      patientId: state.soap && state.soap.patientInfo && state.soap.patientInfo.id
    }),
    {
      saveTempData,
      getPatientActiveMedications,
      getPatientInactiveDiagnosis,
      getPatientInactiveMedication,
      getPatientMedicalHistory,
      getPatientPastDiagnosis,
      getPatientRemarks,
      getPastSoapNoteById,
      getProviders, 
      getPatientCharts
    }
  )(withStyles(styles)(AccountDetails))
);
